module.exports = __webpack_public_path__ + "static/media/kop_surat.4d1f8a9a.png";